var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticClass:"animate__animated animate__fadeIn animate__delay-1s"},[_c('headerD'),_c('div',{staticClass:"container-n",style:(_vm.color ? 'background-color: ' + _vm.color : 'white')},[_vm._t("default")],2),_c('footerD'),_c('Barra')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }